import React from 'react'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import asideModalStore from 'Stores/asideModalStore'
import { observer } from 'mobx-react'
import st from './AddProgrammModal.module.scss'

const AddProgrammModal = () => {
  const { modalValues: modalValue, changeValue, check } = asideModalStore

  const handleInputChange = (e) => {
    const { value } = e.target
    changeValue(value, 'name')
  }

  return (
    <div className={st.fieldSet}>
      <FormField>
        <FormLabel isRequired>Name program:</FormLabel>
        <FormInput isError={check('name')}>
          <input
            type='text'
            placeholder={'Name'}
            name='name'
            value={modalValue?.name || ''}
            onChange={handleInputChange}
            maxLength={35}
          />
        </FormInput>
      </FormField>
    </div>
  )
}

export default observer(AddProgrammModal)
